/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OAuth2Configuration } from '../models/OAuth2Configuration';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class OAuth20Service {

    /**
     * Create OAuth integration
     * @param requestBody
     * @returns OAuth2Configuration OAuth integration created
     * @throws ApiError
     */
    public static postInternalApiOauth2Configurations(
        requestBody: OAuth2Configuration,
    ): CancelablePromise<OAuth2Configuration> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/internal_api/oauth_2_configurations',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                422: `unprocessable entity`,
            },
        });
    }

    /**
     * Retrieve latest OAuth integration
     * @returns void
     * @throws ApiError
     */
    public static getInternalApiOauth2ConfigurationsShowLatest(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal_api/oauth_2_configurations/show_latest',
            errors: {
                401: `not authorized`,
                404: `not found`,
            },
        });
    }

    /**
     * Update OAuth integration
     * @param id OAuth2 Configuration ID
     * @param requestBody
     * @returns OAuth2Configuration OAuth integration updated
     * @throws ApiError
     */
    public static putInternalApiOauth2Configurations(
        id: string,
        requestBody: OAuth2Configuration,
    ): CancelablePromise<OAuth2Configuration> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/internal_api/oauth_2_configurations/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `not authorized`,
                404: `not found`,
            },
        });
    }

}